if (!customElements.get('product-carousel-slide')) {
  customElements.define('product-carousel-slide', class ComponentProductCarouselSlide extends HTMLElement {
    constructor() {
      super();
      this.getElements();
      this.setEventListener();
    }

    getElements() {
      this.originalImage = this.querySelector('.product-images-image');
      this.magnifiedImage = this.querySelector('.product-image-zoomer');
    }

    setEventListener() {
      const isMobileLayout = window.innerWidth < 750;
      if (!isMobileLayout) this.addEventListener('mousemove', (e) => this.handleMouseMoves(e));
      if (!isMobileLayout) this.addEventListener('mouseup', this.handleMouseUp.bind(this));
      if (!isMobileLayout) this.addEventListener('mousedown', this.handleMouseDown.bind(this));
    }

    handleMouseMoves(e) {
      this.style.cursor == 'pointer' ? this.style.cursor = 'zoom-in' : null;
      const style = this.magnifiedImage.style;
      const imageUrl = this.originalImage.src;
      const x = (e.clientX - ((window.innerWidth - this.originalImage.offsetWidth) / 2));
      const y = e.clientY - this.offsetTop;
      const imgWidth = this.originalImage.offsetWidth;
      const imgHeight = this.originalImage.offsetHeight;
      let xperc = (x / imgWidth) * 100;
      let yperc = (y / imgHeight) * 100;

      if (x > 0.01 * imgWidth) {
        xperc += 0.15 * xperc;
      }
      if (y >= 0.01 * imgHeight) {
        yperc += 0.15 * yperc;
      }
      style.background = `url(${imageUrl}) no-repeat #FFF`;
      style.backgroundPositionX = `${xperc - 10}%`;
      style.backgroundPositionY = `${yperc - 20}%`;
      style.left = `${x - 120}px`;
      style.top = `${y - 180}px`;
    }

    handleMouseUp() {
      this.magnifiedImage.style.display = 'block';
      this.style.cursor = 'zoom-in';
    }

    handleMouseDown() {
      this.magnifiedImage.style.display = 'none';
      this.style.cursor = 'pointer';
    }
  })
}
